import {
    getPrice,
    listPrices
} from './queries';
import {
    createPrice,
    deletePrice,
    updatePrice,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {Price} from "../types.ts";
import {generateClient} from "aws-amplify/api";


export type ListPrices = {
    listPrices: { items: Price[], nextToken?: string }
}

export type GetPrice = {
    getPrice: Price
}

export type CreatePrice = {
    createPrice: Price
}

export type UpdatePrice = {
    updatePrice: Price
}

export type DeletePrice = {
    deletePrice: string
}

const client = generateClient();


export const fetchRecords = async (filter: object, limit?: number, nextToken?: string) => {
    const response = await client.graphql<GraphQLQuery<ListPrices>>({
                                                                        query: listPrices,
                                                                        variables: {filter: filter, limit, nextToken},
                                                                    });
    return response.data?.listPrices;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetPrice>>({
                                                                      query: getPrice,
                                                                      variables: {id: id},
                                                                  });
    return response.data?.getPrice;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreatePrice>>({
                                                                         query: createPrice,
                                                                         variables: {input: payload},
                                                                     });
    return response.data?.createPrice;
};

export const update = async (_id: string, record: Price) => {
    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdatePrice>>({
                                                                         query: (updatePrice),
                                                                         variables: {input: record},
                                                                     });
    return response.data?.updatePrice;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeletePrice>>({
                                                                         query: (deletePrice),
                                                                         variables: {input: {id: id}},
                                                                     });
    return response.data?.deletePrice;
};
